import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-minus',
  templateUrl: './icon-account-minus.component.html',
  styleUrl: './icon-account-minus.component.scss',
  standalone: false,
})
export class IconAccountMinusComponent {
  @Input() tooltip?: string;
}
